import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@chakra-ui/react';

type AccessModal = {
  isOpen: boolean;
  onClose: () => void;
};

export const AccessModal = ({ isOpen, onClose }: AccessModal) => {
  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent textAlign="center">
        <ModalHeader>Atenção!</ModalHeader>
        <ModalBody>
          <Text>Ops, acesso inválido ou sessão expirada.</Text>
          <Text>Por favor, refaça o login no Portal do Corretor.</Text>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Link href={process.env.REACT_APP_PORTAL_URL}>
            <Button bg="#FA6B25" color="#fff" colorScheme="orange">
              Portal do Corretor
            </Button>
          </Link>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
